export default __webpack_public_path__ + "static/center-it-48d13909a7f25b5a0300d37de60a6f9b.webp";